import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    data: function() {
        return {
            enablePagination: undefined
        }
    },
    components: {
        swiper: Swiper,
        slide: SwiperSlide
    },
    computed: {
        options({ enableNavigation, enablePagination }) {
            let options = {
                speed: this.speed,
                spaceBetween: this.spaceBetween,
                slidesPerGroup:
                    this.slideMode == 'full' ? this.slidesPerView : 1,
                slidesPerView: this.slidesPerView,
                loop: this.loop && this.testimonials.length > this.slidesPerView
            };
           
            if (enableNavigation !== false) {
                options.navigation = {
                    closest: ".md-testimonial",
                    prevEl: '.prevbutton',
                    nextEl: '.nextbutton',
                    disabledClass: 'navigation-disabled'
                };
            }
            if (
                enablePagination !== false &&
                // this.testimonials.length <= 6 &&
                this.testimonials.length > 1
            ) {
                options.pagination = {
                    closest: ".md-testimonial",
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                };
            }
            if (this.autoPlay) {
                options.autoplay = {
                    delay: this.delayTime,
                    disableOnInteraction: false
                };
            } else {
                options.autoplay = false;
            }
            if (this.platform.isMobile) {
                options = Object.assign(options, {
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                    slidesPerView: 1
                });
            }
            options = fixSwiperOptions(options);
            return options;
        }
    },
    watch: {
        fullColumn() {
            this.$nextTick(() => {
                if (this.swiper) {
                    this.swiper.update(); 
                }
            });
        }
    }
};
